export default __webpack_public_path__ + "static/media/roadHome.81491c9d.png";